import LBox from "@components/LBox";
import LText from "@components/LText";
import { theme } from "@theme";
import type { AccessPresentation } from "@libs/utils";

type AccessTypePillProps = {
  presentation: AccessPresentation;
  compact?: boolean;
};

const toneColors = {
  concert: {
    backgroundColor: theme.colors.accessTypeConcertBg,
    color: theme.colors.accessTypeConcertText,
  },
  music: {
    backgroundColor: theme.colors.accessTypeMusicBg,
    color: theme.colors.accessTypeMusicText,
  },
  online: {
    backgroundColor: theme.colors.accessTypeOnlineBg,
    color: theme.colors.accessTypeOnlineText,
  },
  merch: {
    backgroundColor: theme.colors.accessTypeMerchBg,
    color: theme.colors.accessTypeMerchText,
  },
} satisfies Record<AccessPresentation["tone"], object>;

const AccessTypePill = ({
  presentation,
  compact = false,
}: AccessTypePillProps) => {
  const colors = toneColors[presentation.tone];

  return (
    <LBox
      borderRadius="max"
      bg="screenBg"
      alignSelf="flex-start"
      style={{ padding: 1 }}
    >
      <LBox
        borderRadius="max"
        style={{ backgroundColor: colors.backgroundColor }}
        px={compact ? "s0_75" : "s1_25"}
        py="s0_25"
      >
        <LText variant="Caption/C2/Medium" style={{ color: colors.color }}>
          {presentation.label}
        </LText>
      </LBox>
    </LBox>
  );
};

export default AccessTypePill;
